import React, { useRef, useEffect } from 'react';
import './HeroBanner.css';

function HeroBanner() {
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;

    const checkTime = () => {
      if (video && video.currentTime >= 54) {
        video.currentTime = 0;
        video.play();
      }
    };

    video.addEventListener('timeupdate', checkTime);

    return () => {
      video.removeEventListener('timeupdate', checkTime);
    };
  }, []);

  return (
    <section className="hero-banner">
      <video
        ref={videoRef}
        className="hero-video"
        autoPlay
        muted
        playsInline
      >
        <source src="/videos/videoofTech.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      <div className="hero-overlay"></div>

      <div className="hero-content">
        <h1 className="hero-title">
          <span className="slide-left">Empowering </span>
          <span className="slide-right">Innovation </span>
          <span className="slide-top">Across </span>
          <span className="slide-bottom">10+ Industries</span>
        </h1>


        
        <p className="hero-subtitle">
          From Technology to Textiles, Healthcare to Hospitality — Klyzen Ventures LLP is building the future across diverse sectors.
        </p>

        <a href="#services" className="hero-btn">Explore Divisions</a>
      </div>
    </section>
  );
}

export default HeroBanner;





